module.exports = __webpack_public_path__ + "img/hr-iron-ore.08fbadd6.png";